import Component from './login.vue'
export default Component
